/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { color, pxToEm, centerAbsolutely, imageTypes, animations, mediaQuery, backgrounds, spacing, replacePXinStringWithEM } from 'utils/styles';
import { url } from 'utils/urls';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// OPTIN STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default {
    uniquecontent: {
    	'& .optin': {
            '& .dimmer': {
                // opacity: '.5',
                // background: color.black,
                width: '100%',
                height: '100%',
                position: 'absolute',
                top: '0',
                left: '0',
                zIndex: '1'
            },
            '& .group': {
                display: 'table',
                borderTopLeftRadius: pxToEm(3),
                borderTopRightRadius: pxToEm(3),
                borderBottomLeftRadius: pxToEm(9.5),
                borderBottomRightRadius: pxToEm(9.5),
                background: color.blueLight,
                height: pxToEm(106),
                width: '100%',
                padding: `0 ${spacing.sides}`,
                position: 'absolute',
                bottom: '0',
                left: '0',
                zIndex: '2',
                '& .bodycopy, .ctas': {
                    display: 'table-cell',
                    textAlign: 'left',
                    verticalAlign: 'middle'
                },
                '& .bodycopy': {
                    padding: replacePXinStringWithEM('20px 20px 20px 0'),
                    '& .logo': {
                        marginBottom: pxToEm(10)
                    },
                    '& p': {
                        color: color.white,
                        fontSize: pxToEm(10),
                        marginBottom: pxToEm(0),
                        '& a': {
                            color: color.white
                        }
                    }
                },
                '& .ctas': {
                    '& .button': {
                        width: pxToEm(83)
                    }
                }
            }
	    }
    }
};
